import {connect} from 'react-redux';
import * as selectors from '../application.selectors'

const Unauthorized = ({epasrr}) => {
  return epasrr ? (
    window.location = epasrr
  ) : null;
};

export default connect(
  state => ({
    epasrr: selectors.epasrrUrl(state)
  }),
)(Unauthorized);



// WEBPACK FOOTER //
// ./src/components/401.js